import Team from '../components/team.svelte'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
// const { $ } = window
gsap.registerPlugin(ScrollTrigger)

export default {
	init() {
		animateVenturesHero()
		animateVenturesApproach()
		animateVenturesDynamic()
		animateDocuments()
		animateDisclaimers()

		let $teamWrap = $('#team-wrap')
		if ($teamWrap.length) {
			new Team({
				target: $teamWrap[0],
			})
		} else {
			gsap.set('.team-member', {autoAlpha: 0, y: 32 })
			setTimeout(() => {
				gsap.set('.team-member', {autoAlpha: 0, y: 32 })
				Array.from(document.querySelectorAll('.team-member')).forEach( (el, idx) => {
					gsap.to(el, {scrollTrigger: { trigger: el, start: 'top 90%' }, delay: 0.1*(idx%4), y: 0, autoAlpha: 1, duration: 0.35 })
				})
			}, 200)
		}

	},
	finalize() {},
}

function animateVenturesHero() {
	const ventureHeroTimeLine = gsap.timeline({
		defaults: {
			opacity: 1,
			x: 0,
			y: 0,
			ease: 'power1.out',
			duration: 0.65,
			stagger: 0.2,
		},
	})
	let subHeroCopy = document.querySelectorAll('.sub-hero-copy p')
	subHeroCopy.forEach((p) => gsap.set(p, { x: -16, opacity: 0 }))
	gsap.set('.hero-content h2', { x: -32 })
	gsap.set('.sub-hero-title', { x: -16, opacity: 0 })
	gsap.set('.hero-img', { opacity: 0 })
	gsap.set('.sub-hero-img', { opacity: 0 })

	ventureHeroTimeLine
		.to('.hero-content h2', {
			opacity: 1,
			x: 0,
			ease: 'power1.out',
			duration: 0.65,
		})
		.to('.hero-img', {}, '-=0.65')
		.to('.sub-hero-title', {})
		.to(subHeroCopy, {})
		.to('.sub-hero-img', {}, '-=0.65')
}

function animateVenturesApproach() {
	const approachSection = document.querySelector('.ventures-approach-wrap')
	let vawBody = document.querySelectorAll('.vaw-header-wrap p')
	vawBody.forEach((p) => gsap.set(p, { y: 16, opacity: 0 }))
	let vawCards = document.querySelectorAll('.vaw-card')
	vawCards.forEach((card) => gsap.set(card, { y: 16, opacity: 0 }))
	gsap.set('.vaw-header', { opacity: 0, y: 32 })
	gsap
		.timeline({
			scrollTrigger: { trigger: approachSection, start: 'top 90%' },
			defaults: { opacity: 1, duration: 0.65, stagger: 0.2, y: 0, x: 0 },
		})
		.to('.vaw-header', {})
		.to(vawBody, {})
		.to(vawCards, {}, '-=0.65')
}

function animateVenturesDynamic() {
	const fourWrap = document.querySelector('.vd-four-wrap')
	const eightWrap = document.querySelector('.vd-eight-wrap')
	if (fourWrap) {
		let fourCards = fourWrap.querySelectorAll('.card')
		gsap.set(fourCards, { opacity: 0, y: 16 })

		gsap.to(fourCards, {
			scrollTrigger: fourWrap,
			opacity: 1,
			y: 0,
			stagger: 0.2,
			duration: 0.65,
		})
	} else {
		let eightCards = eightWrap.querySelectorAll('.eight-card')
		gsap.set(eightCards, { opacity: 0, y: 16 })

		gsap.to(eightCards, {
			scrollTrigger: eightWrap,
			opacity: 1,
			y: 0,
			stagger: 0.2,
			duration: 0.65,
		})
	}
	const ctaColumns = gsap.utils.toArray('.cta-column')

	ctaColumns.forEach((cta) => {
		let preHeading = cta.querySelector('.pre-heading')
		let heading = cta.querySelector('h3')
		let btn = cta.querySelector('.btn')

		gsap.set(preHeading, { opacity: 0, x: -16 })
		gsap.set(heading, { opacity: 0, x: -32 })
		gsap.set(btn, { opacity: 0 })

		gsap
			.timeline({
				scrollTrigger: {
					trigger: cta,
					start: 'top 90%',
				},
				defaults: { opacity: 1, x: 0, y: 0, duration: 0.65 },
			})
			.to(preHeading, {})
			.to(heading, {}, '-=0.65')
			.to(btn, {})
	})
}

function animateDisclaimers() {
	const disclaimersWrap = gsap.utils.toArray('.disclaimer-wrap')

	disclaimersWrap.forEach((disclaimer, index) => {
		const mainDisclaimer = disclaimer.querySelector('.disclaimer-copy')
		const additionalDisclaimer = disclaimer.querySelector(
			'.additional-disclaimer-wrap'
		).children

		gsap.set(mainDisclaimer, { opacity: 0, y: 16 })
		gsap.set(additionalDisclaimer, { opacity: 0, y: 16 })

		gsap
			.timeline({
				scrollTrigger: {
					trigger: disclaimer,
					start: 'top 90%',
				},
				defaults: {
					opacity: 1,
					y: 0,
					delay: index * 0.3,
					stagger: 0.2,
				},
			})
			.to(mainDisclaimer, {})
			.to(additionalDisclaimer, {})
	})
}

function animateDocuments() {
	const documentSections = gsap.utils.toArray('.documents-filings')

	documentSections.forEach((section) => {
		const docTitle = section.querySelector('.h3')
		const docs = section.querySelectorAll('.btn')

		gsap.set(docTitle, { opacity: 0, y: 16 })
		gsap.set(docs, { opacity: 0 })

		gsap
			.timeline({
				scrollTrigger: {
					trigger: section,
					start: 'top 90%',
				},
				defaults: { opacity: 1, x: 0, y: 0, duration: 0.65, stagger: 0.2 },
			})
			.to(docTitle, {})
			.to(docs, {}, '-=0.65')
	})
}
